export default __webpack_public_path__ + "static/media/logoSimple.31cd2dc4.png";